export default __webpack_public_path__ + "static/media/page1.2ee9450a.png";